import React from "react";
import useAuth from "../../../hooks/useAuth";

interface PermissionProps {
  requiredPermission?: string;
  requiredPermissions?: string[];
  children: React.ReactNode;
}

/**
 * Permission evaluates exact UI components rendering them exclusively if the connected User
 * explicitly possesses `requiredPermission` strings internally mitigating forbidden access dynamically.
 */
const Permission = ({ requiredPermission, requiredPermissions, children }: PermissionProps) => {
  const { rolePermissions } = useAuth();

  let hasPermission = false;
  if (requiredPermissions && requiredPermissions.length > 0) {
    hasPermission = requiredPermissions.some((rp) => rolePermissions?.includes(rp));
  } else if (requiredPermission) {
    hasPermission = rolePermissions?.includes(requiredPermission) || false;
  }

  if (!hasPermission) {
    return null;
  }

  return <>{children}</>;
};

export default Permission;
